import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getConfiguredLabel } from "../../../../common/commonHelper";
import {
  DataListTemplates,
  DataTypes,
  TemplateTypes,
} from "../../../../common/constants";
import {
  addButton,
  addDocPopUp,
  cancelButton,
  deleteButton,
  deleteDocPopUp,
  deleteMessage,
  documents,
  DocumentsPage,
  editDocPopUp,
  editToaster,
  editToasterMessage,
  HeaderMenu,
  myDocInsideAllDocPage,
  saveButton,
  tabName,
  uploadButton,
} from "../../../../common/labelConstants";
import { usePermissions } from "../../../../hooks/usePermissions";

import { RenderIcons } from "../../../controls/icons";
import DataListing from "../../../listing/listing";
import { UploadButton } from "../../uploadButton";
import { DocumentAnalyticsInfo } from "../analytics/docAnalyticsInfo";

const _props = {
  handleDownloadFile: (selectedRows, setSelectedRows) => {},
  handleDeleteDoc: (rows, refresh, showDeletePopup) => {},
};
function AllDocuments(props = _props) {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const permissions = usePermissions();
  const chartConfig = useSelector((x)=>x.chart.chartConfig);
  
  if(chartConfig && chartConfig.widgets)
  {
    var chartConfigObject=chartConfig.widgets.find(x => x.moduleName === DataListTemplates.allDocuments);
  }


  const handleUserRowData = (rowData) => {
    if (
      (userInfo.email || "").toLowerCase() ==
      (rowData.createdByEmail || "").toLowerCase()
    )
      return "current-user";
    else return "not-current-user";
  };

  const actionToaster = {
    edit: {
      title: getConfiguredLabel(DocumentsPage, editToaster),
      message: getConfiguredLabel(DocumentsPage, editToasterMessage),
    },
  };

  return (
    <div>
     {chartConfigObject ?  <DocumentAnalyticsInfo
        dataListTemplate={DataListTemplates.allDocuments}
        chartConfig={chartConfigObject}
      />:<></>}

      <DataListing
        paginator={true}
        dataType_id={DataTypes.Documents.id}
        handleDelete={(rows, refreshData_fn, showDeletePopup) =>
          props.handleDeleteDoc(rows, refreshData_fn, showDeletePopup)
        }
        templateName={DataListTemplates.allDocuments}
        handleDownload={props.handleDownloadFile}
        rowClass={handleUserRowData}
        actionToaster={actionToaster}
        renderHeaderAreaLeft={({ pagingInfo }) => {
          return (
            <>
              {pagingInfo}
              <div className="list_left_docs">
                <span className="list_left_block"></span>
                <span>
                  {getConfiguredLabel(DocumentsPage, myDocInsideAllDocPage)}
                </span>
              </div>
            </>
          );
        }}
        pageActionsInfo={{
          add: {
            title: getConfiguredLabel(DocumentsPage, addDocPopUp),
            message: "",
            actions: {
              ok: { label: getConfiguredLabel(DocumentsPage, addButton) },
              cancel: {
                label: getConfiguredLabel(DocumentsPage, cancelButton),
              },
            },
          },
          edit: {
            title: getConfiguredLabel(DocumentsPage, editDocPopUp),
            message: "",
            actions: {
              ok: { label: getConfiguredLabel(DocumentsPage, saveButton) },
              cancel: {
                label: getConfiguredLabel(DocumentsPage, cancelButton),
              },
            },
          },
          delete: {
            title: getConfiguredLabel(DocumentsPage, deleteDocPopUp),
            message: getConfiguredLabel(DocumentsPage, deleteMessage),
            actions: {
              ok: { label: getConfiguredLabel(DocumentsPage, deleteButton) },
              cancel: {
                label: getConfiguredLabel(DocumentsPage, cancelButton),
              },
            },
          },
        }}
        renderHeaderAreaRight={({
          btn_download,
          btn_delete,
          filter_global,
          orderBy_icon,
          sortBy_dropdown,
          selectedRows,
          setSelectedRows,
        }) => {
          return (
            <>
              {filter_global}
              <span
                className="download_icon"
                onClick={() => {
                  props.handleDownloadFile(selectedRows, setSelectedRows);
                }}
              >
                {RenderIcons("download")}
              </span>
              <span>{permissions.FullControl ? btn_delete : null}</span>
              {sortBy_dropdown}
              {/* {selectedRows}  */}
            </>
          );
        }}
        testActionAgainstData={{
          edit: (row) => {
            let renderRow = false;
            if (
              handleUserRowData(row) == "current-user" ||
              permissions.FullControl
            ) {
              renderRow = true;
            }
            return renderRow;
          },
          delete: (row) => {
            return permissions.FullControl ? true : false;
          },
        }}
      />
    </div>
  );
}
export default AllDocuments;
